(function (window) {
  'use strict';

  const confirmationNames = document.querySelector('.reserve-in-store--request-received--customer-name');
  const confirmationEmail = document.querySelector('.icon-step--check-your-email .icon-step__details');
  const modalForm = document.querySelector('.js-modal-form.modal-form--reserve-in-store');

  function init() {
    if (modalForm && !modalForm.classList.contains('js-component-init')) {
      if(confirmationNames) {
        confirmationNames.setAttribute('data-content', btoa(confirmationNames.innerHTML));
      }

      if(confirmationEmail) {
        confirmationEmail.setAttribute('data-content', btoa(confirmationEmail.innerHTML));
      }

      modalForm.classList.add('js-component-init');
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
